
import { Options, Vue } from 'vue-class-component';
import { Prop, Watch } from 'vue-property-decorator';
import { NButton } from '@/uikit';
import { FaceCluster } from '@/api';
import { ClusterView } from '@/components/clusters/adapter';
import SimpleReaction from '@/components/common/SimpleReaction.vue';
import Features from '@/components/common/Features.vue';
import MatchedCardInfo from '@/pages/events/MatchedCardInfo.vue';
import ClusterEventItem from '@/pages/clusters/ClusterEventItem.vue';
import Statistics from '@/components/common/Statistics.vue';
import SortDropdown from '@/components/common/SortDropdown.vue';
import { viewModelRepository } from '@/api/common';
import { dataAssetsModule } from '@/store/application/data.assets.module';
import { ObjectsMultiToSingle, ObjectType } from '@/store/application/data.assets';
import ConfidenceDelimiter from '@/components/common/ConfidenceDelimiter.vue';
import ImageViewer from '@/components/image-viewer/ImageViewer.vue';
import { NModalWindow } from '@/uikit';
import { actionHandler } from '@/store/data/ActionHandler';
import { ItemsActionName, ItemsActionNames } from '@/definitions/app/item.actions.name';
import CardConfidence from '@/components/cards/CardConfidence.vue';
import Confidence from '@/components/common/Confidence.vue';

@Options({
  name: 'ClustersSidebarContent',
  components: {
    Confidence,
    CardConfidence,
    MatchedCardInfo,
    NButton,
    SimpleReaction,
    Features,
    ClusterEventItem,
    Statistics,
    SortDropdown,
    ConfidenceDelimiter,
    ImageViewer,
    NModalWindow
  }
})
export default class ClustersSidebarContent extends Vue {
  @Prop({ type: Object, required: true })
  readonly item!: FaceCluster;

  @Prop({ type: Object, required: true })
  readonly clusterView!: ClusterView;

  @Prop({ type: String, required: true })
  readonly objectType!: string;

  @Prop({ type: String, required: true })
  readonly cardType!: string;

  created() {
    const id = Number(this.item?.id);
    this.module.filter.current.limit = '1000';
    this.module.filter.current.cluster_in = [id];
    this.load();
  }

  get sortTypes(): any[] {
    return dataAssetsModule.getSortTypes({ id: true }).map((v) => ({ ...v, label: this.$t(v.i18n_label) }));
  }

  get type(): ObjectType {
    return (ObjectsMultiToSingle[this.objectType] as ObjectType) ?? 'face';
  }

  get module() {
    switch (this.objectType) {
      case 'cars':
        return viewModelRepository.getClusterEventsCarsListViewModel();

      case 'bodies':
        return viewModelRepository.getClusterEventsBodiesListViewModel();

      default:
        return viewModelRepository.getClusterEventsFacesListViewModel();
    }
  }

  async actionHandler(v: ItemsActionName, payload?: any) {
    if (v === ItemsActionNames.Delete) {
      await this.module.delete(payload.id);
      await this.module.get();
    } else {
      await actionHandler.run(v, payload);
    }
  }

  load() {
    this.module.get();
  }

  @Watch('module.filter.current.ordering')
  changeOrderingHandler() {
    this.module.get();
  }

  @Watch('item.id')
  changeIdHandler(v: number) {
    this.module.filter.current.cluster_in = [v];
    this.module.get();
  }
}
